export default __webpack_public_path__ + "static/media/bancs-3.82956c6e.png";